// src/features/hmi-simulator/components/screens/ProvisionScreen.tsx
import React from 'react';
import {
  Container,
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Alert,
  Stack,
  CircularProgress
} from '@mui/material';
import { Lock } from '@mui/icons-material';

interface ProvisionScreenProps {
  provisioningCode: string;
  setProvisioningCode: (value: string) => void;
  error: string;
  apiLoading: boolean;
  onProvision: () => void;
}

export const ProvisionScreen: React.FC<ProvisionScreenProps> = ({
  provisioningCode,
  setProvisioningCode,
  error,
  apiLoading,
  onProvision
}) => {
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && provisioningCode) {
      onProvision();
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Card sx={{ width: '100%', p: 4 }}>
          <CardContent>
            <Box sx={{ textAlign: 'center', mb: 4 }}>
              <Lock sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
              <Typography variant="h5" gutterBottom>
                Device Provisioning
              </Typography>
              <Typography color="text.secondary">
                Enter the provisioning code to activate this HMI
              </Typography>
            </Box>
            
            <Stack spacing={2}>
              <TextField
                fullWidth
                label="Provisioning Code"
                value={provisioningCode}
                onChange={(e) => setProvisioningCode(e.target.value.toUpperCase())}
                onKeyPress={handleKeyPress}
                placeholder="TEST-1234"
                helperText="Test code: TEST-1234"
                autoFocus
                inputProps={{ style: { textTransform: 'uppercase' } }}
              />
              
              {error && <Alert severity="error">{error}</Alert>}
              
              <Button
                fullWidth
                variant="contained"
                onClick={onProvision}
                disabled={!provisioningCode || apiLoading}
                size="large"
              >
                {apiLoading ? <CircularProgress size={24} color="inherit" /> : 'Provision Device'}
              </Button>
            </Stack>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};